// Third party
import { useQuery } from '@tanstack/react-query';

// Hooks
import { useAppDispatch } from '../../useAppStore';
import { ProfileController } from '../../../services';

// Components
import { useError } from '../../useError';
import { QUERY_KEYS } from '../../../utils';
import { profileDataActions } from '../../../store';
import { TAxiosError, TGetProfileInfoRes } from '../../../types/responses';

const useGetShooterProfileInfo = () => {
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();

  return useQuery({
    queryKey: [QUERY_KEYS.PROFILE.SHOOTER_PROFILE],
    queryFn: async () => {
      try {
        const rsp = await ProfileController().getShooterProfileInfo<TGetProfileInfoRes>();
        dispatch(profileDataActions.setProfileInfo(rsp.data))
        return rsp;
      } catch (err) {
        await handleReqError(err as TAxiosError);
      }
    },
    enabled: false,
  });
};

export { useGetShooterProfileInfo };
